import api from "../api";

// 🔹 Register
export const register = (data) => {
  return api.post("/api/register", data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

// 🔹 Login
export const login = async (formData) => api.post("/api/login", formData);

// 🔹 Logout
export const logout = async () => api.post("/api/logout");

// 🔹 Get authenticated user
export const getUser = async () => api.get("/api/user");

// 🆕 Update Profile
export const updateProfile = (data) => api.post("/api/update-profile", data);

// 🆕 Change Password
export const changePassword = (data) => api.post("/api/change-password", data);

// 🆕 Forgot Password
export const forgotPassword = (data) => api.post("/api/forgot-password", data);
